import 'lightpick/scss/lightpick.scss';
import '../../scss/modules/v_lightpick/_lightpick.default.scss';
import Lightpick from 'lightpick';
import moment from 'moment';
import { match } from '../utilities/ResolutionHandler';
import BaseComponent from '../abstracts/BaseComponent';
import { DataLayerUtils } from '../utilities/DataLayer';
import { get } from '../libs/Axios';

export default class RentCalendarComponent extends BaseComponent {
  get INPUT() {
    const input = document.createElement('input');
    input.classList.add('js-calendar');
    input.classList.add('hide');

    return input;
  }

  get SELECTORS() {
    return {
      calendar: '.js-calendar'
    };
  }

  get BASE_CONF() {
    return {
      singleDate: false,
      inline: true,
      dropdowns: false,
      hoveringTooltip: false,
      numberOfMonths: 2,
      numberOfColumns: 2,
      separator: '  >  ',
      disableWeekends: true,
      // customDate: moment('2020-03-05').set('date', 1), da usare per far partire il calendario con una data custom diversa dalla corrente
      disableDates: this.$options.disableddates ? JSON.parse(this.$options.disableddates).map(el => moment(el)) : null,
      onSelectStart: (date) => {
        this.setRange(date);
        DataLayerUtils.push({
          gaHitType: 'event',
          event: 'popup_interactions',
          eventCategory: 'popup',
          eventAction: 'click_calendar',
          eventLabel: 'start'
        });
      }
    };
  }

  get dates() {
    return this.picker && this.picker.getStartDate() ? {
      rangeStart: this.picker.getStartDate().format(),
      rangeStartString: this.picker.getStartDate().format('DD.MM.YYYY'),
      rangeEnd: this.picker.getEndDate().format(),
      rangeEndString: this.picker.getEndDate().format('DD.MM.YYYY')
    } : null;
  }

  set baseRange(value) {
    this.range = Number(value);

    if (this.picker && this.picker.getStartDate()) {
      this.setRange(this.picker.getStartDate());
    }
  }

  constructor(element, endDateUrl) {
    super(element);

    this.endDateUrl = endDateUrl;
    this.range = this.$options.baseRange || 4;

    // this.$el.appendChild(this.INPUT);

    const minDate = new Date(Number(this.$options.suitablestartdate));
    const maxDate = new Date(Date.now() + 24 * 86400000);

    this.picker = new Lightpick({
      ...this.BASE_CONF,
      field: this.$el.querySelector(this.SELECTORS.calendar),
      minDate,
      maxDate
    });

    // if (match('medium')) {
    //   this.picker.reloadOptions({
    //     numberOfMonths: 2
    //   });
    // }
  }

  // async importLightpick() {
  //   let Lightpick;
  //   try {
  //     this.moment = moment;
  //     await import(
  //       /* webpackChunkName: "lightpick-css" */ 'lightpick/scss/lightpick.scss'
  //     );
  //     await import('../../scss/modules/v_lightpick/_lightpick.default.scss');
  //     Lightpick = await import(/* webpackChunkName: "lightpick" */ 'lightpick');
  //   } catch (e) {
  //     console.error(e);
  //   }
  //   return Lightpick;
  // }

  async getEndDate(startDate) {
    let res;
    try {
      res = await get(this.endDateUrl, {
        params: {
          startDateTimestamp: isNaN(startDate) ? moment(startDate).format('x') : Number(startDate),
          range: this.range
        }
      });
    } catch (e) {
      console.error(e);
    }

    return res.data;
  }

  async setRange(startDate) {
    try {
      const { endDate } = await this.getEndDate(startDate);
      const baseDate = typeof startDate === 'string' ? moment(!isNaN(startDate) ? new Date(Number(startDate)) : startDate) : startDate;
      this.picker.setDateRange(
        baseDate.format(),
        moment(endDate).format(),
        true
      );

      const btn = document.querySelector('.js-apply-configs');
      btn.disabled = false;
    } catch (e) {
      console.error(e);
    }
  }
}
